import { IAzureSearchFacet } from "@/shared/services/azure-search-service";
import { IFilterItem } from "../../models/filter-item-model";
import IFilterGroup from "../../models/filter-group-model";
import { BaseFilterService } from "../base-filter-service";


export class PureFilterService extends BaseFilterService {
    public initialize(): IFilterGroup[] {
        this.userFilters = this.setFilterGroups();
        return this.userFilters;
    }

    public shouldDisable(filterGroup: IFilterGroup, filterItem: IFilterItem): boolean {
        return !Object.values(this.searchFilters)
            .flat()
            .map(x => x.value)
            .includes(filterItem.FilterCodeName);
    }

    private setFilterGroups(): IFilterGroup[] {
        return Object.keys(this.searchFilters).map((key: string) => {
            return {
                DisplayName: this.labels[key == 'Model/Faculties' ? 'facultyFilter' : 'instituteFilter'],
                FilterItems: this.setFilterItems(this.searchFilters[key], key),
                UseImplicitFilters: false
            };
        });
    }

    private setFilterItems(searchFilterItems: IAzureSearchFacet[], searchFilterGroup: string): IFilterItem[] {
        var filters = searchFilterItems.map((x: IAzureSearchFacet) => {
            return {
                DisplayName: x.value,
                FilterCodeName: x.value,
                CodeName: x.value,
                Selected: false,
                Disabled: false,
                IsExplicit: true,
                IsImplicit: false,
                FilterGroup: searchFilterGroup
            };
        });

        return filters.sort((a, b) => a.DisplayName.localeCompare(b.DisplayName));
    }
}
